import { createComponentStore } from '../../utils/createComponentStore';

const emptyData = () => ({
  gatewayType: 'inclusive',
});

const { getStore: getGatewayStore, defaultStore } = createComponentStore({
  type: 'gateway',
  endpoint: 'gateway',
  registryKey: 'gateway',
  initData: emptyData,
  onLoadData: (rawData) => ({
    ...emptyData(),
    ...rawData,
  }),
  extraActions: (set, get) => ({
    setGatewayType: (value) =>
      set({ data: { ...get().data, gatewayType: value } }),
  }),
});

export { getGatewayStore };
export default defaultStore;
